import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://maclectic.com';
const DEFAULT_TITLE = 'Maclectic — Suivi nutrition, poids et sommeil';
const DEFAULT_DESCRIPTION = 'Suivez votre alimentation, votre sommeil et votre poids avec Maclectic. Visualisez vos progrès et avancez à votre rythme.';

const PAGE_METADATA = {
  '/': {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    index: true,
  },
  '/about': {
    title: 'À propos de Maclectic — Nutrition et bien-être',
    description: 'Découvrez Maclectic, une application pour suivre votre alimentation, votre sommeil et votre poids au même endroit.',
    index: true,
  },
  '/legal': {
    title: 'Informations légales — Maclectic',
    description: 'Consultez les informations légales et les conditions d’utilisation de Maclectic.',
    index: true,
  },
  '/offers': {
    title: 'Offres et abonnements — Maclectic',
    description: 'Découvrez les offres Maclectic et choisissez les fonctionnalités adaptées à votre suivi.',
    index: true,
  },
};

const setMeta = (selector, attribute, key, value) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', value);
};

const setCanonical = (url) => {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', url);
};

const SeoMetadata = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
    const page = PAGE_METADATA[normalizedPath];
    const title = page?.title || DEFAULT_TITLE;
    const description = page?.description || DEFAULT_DESCRIPTION;
    const canonicalUrl = `${SITE_URL}${normalizedPath === '/' ? '/' : normalizedPath}`;

    document.title = title;
    setMeta('meta[name="description"]', 'name', 'description', description);
    setMeta('meta[name="robots"]', 'name', 'robots', page?.index ? 'index,follow' : 'noindex,follow');
    setMeta('meta[property="og:title"]', 'property', 'og:title', title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', description);
    setMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);

    if (page?.index) {
      setCanonical(canonicalUrl);
    } else {
      document.head.querySelector('link[rel="canonical"]')?.remove();
    }
  }, [pathname]);

  return null;
};

export default SeoMetadata;
